import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {WeekData} from '../model/week-data';
import {WeekRepository} from '../repositories/week.repository';

@Injectable()
export class WeekService {

  constructor(
    private weekRepository: WeekRepository,
  ) { }

  public getWeekData(): Observable<WeekData> {
    return this.weekRepository.getWeekData();
  }

}
